/*
  Окно «Вставить из таблицы Excel» (23.10.2026, решение владельца по макету 6А «сделать все
  три»).

  Человек выделяет строки в своей таблице, копирует и вставляет в поле. Столбцы по порядку:
  месяц, услуга, начислено, дальше необязательные оплачено и срок оплаты. Разбирает текст
  сервер - теми же правилами, что файл, - и возвращает каждую строку: как понял и что в ней
  не так. Внести можно только вставку без единой ошибки, одной операцией; правка текста
  после проверки снова требует проверки, иначе внесено было бы не то, что показано.
*/

import { useState } from 'react'

import { api } from '../../api/client.js'
import { chargeMonth, date, money, plural } from '../../api/format.js'
import { Field, Notice } from '../Common.jsx'
import FormDialog from './FormDialog.jsx'

const EXAMPLE = '08.2026\tотопление\t3 100,00\n07.2026\tотопление\t3 100,00\t1 000,00'

function PreviewTable({ rows }) {
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Строка</th>
          <th>Месяц</th>
          <th>Услуга</th>
          <th className="table__num">Начислено</th>
          <th className="table__num">Оплачено</th>
          <th>Срок оплаты</th>
          <th>Что не так</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.line}>
            <td>{row.line}</td>
            <td data-label="Месяц">{row.period ? chargeMonth(row.period) : '-'}</td>
            <td data-label="Услуга">{row.service || '-'}</td>
            <td className="table__num" data-label="Начислено">
              {row.amount === null ? '-' : money(row.amount)}
            </td>
            <td className="table__num" data-label="Оплачено">
              {row.paid_amount === null ? '-' : money(row.paid_amount)}
            </td>
            <td data-label="Срок оплаты">{row.due_date ? date(row.due_date) : 'нет'}</td>
            <td className="table__block" data-label="Что не так">
              {row.error ?? 'годится'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default function ChargePasteDialog({ accountId, onSaved, onClose }) {
  const [text, setText] = useState('')
  // Предпросмотр помнит текст, по которому сделан: правка текста его обесценивает.
  const [preview, setPreview] = useState(null)
  const [checking, setChecking] = useState(false)
  const [error, setError] = useState(null)

  const fresh = preview !== null && preview.text === text
  const ready = fresh && preview.answer.refused === 0 && preview.answer.ready > 0

  async function check() {
    setChecking(true)
    setError(null)
    try {
      setPreview({ text, answer: await api.previewChargePaste(accountId, text) })
    } catch (failure) {
      setPreview(null)
      setError(failure)
    }
    setChecking(false)
  }

  const count = ready ? preview.answer.ready : 0
  return (
    <FormDialog
      title="Вставить из таблицы Excel"
      note="Месяц, услуга, начислено; при наличии - оплачено и срок оплаты"
      submitLabel={ready ? `Внести ${plural(count, 'строку', 'строки', 'строк')}` : 'Внести строки'}
      canSubmit={ready}
      wide
      onSubmit={() => api.addChargePaste(accountId, text)}
      onSaved={onSaved}
      onClose={onClose}
    >
      <Field label="Строки из таблицы">
        <textarea
          className="field__input"
          rows={8}
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder={EXAMPLE}
        />
      </Field>
      <div className="row row--tight">
        <button
          className="button button--quiet"
          type="button"
          disabled={checking || text.trim() === ''}
          onClick={check}
        >
          {checking ? 'Проверяем…' : 'Проверить строки'}
        </button>
        {preview !== null && !fresh ? (
          <span className="muted">Текст изменён после проверки - проверьте заново.</span>
        ) : null}
      </div>
      <Notice error={error} />
      {fresh ? (
        <>
          {preview.answer.refused > 0 ? (
            <Notice kind="warn">
              Ошибки в строках: {preview.answer.refused}. Исправьте их в таблице и вставьте
              заново - пока ошибки есть, не вносится ничего.
            </Notice>
          ) : null}
          <PreviewTable rows={preview.answer.rows} />
        </>
      ) : null}
    </FormDialog>
  )
}
